var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper generate-reports-page"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _vm._m(0), _vm.requiresTarget ? _c('div', {
    staticClass: "target-picker-bar"
  }, [_vm._m(1), _c('div', {
    staticClass: "target-picker-options"
  }, _vm._l(_vm.targetOptions, function (option) {
    return _c('button', {
      key: option.agent_id,
      staticClass: "target-chip",
      class: {
        active: _vm.selectedTargetAgentId === option.agent_id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.selectedTargetAgentId = option.agent_id;
        }
      }
    }, [_c('i', {
      staticClass: "fas",
      class: _vm.selectedTargetAgentId === option.agent_id ? 'fa-check-circle' : 'fa-circle'
    }), _vm._v(" " + _vm._s(option.name) + " ")]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "reports-card"
  }, [_vm.isLoadingCatalog ? _c('div', {
    staticClass: "empty-state py-5"
  }, [_c('spinner-grow'), _c('p', {
    staticClass: "mb-0 mt-2"
  }, [_vm._v("Loading your report options...")])], 1) : !_vm.reportGroups.length ? _c('div', {
    staticClass: "empty-state py-5"
  }, [_c('i', {
    staticClass: "fas fa-folder-open"
  }), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("No reports are enabled for your account yet.")])]) : _c('div', [_c('div', {
    staticClass: "catalog-toolbar"
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search reports..."
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value;
      }
    }
  })]), !_vm.searchQuery && _vm.reportGroups.length > 1 ? _c('div', {
    staticClass: "category-nav"
  }, _vm._l(_vm.reportGroups, function (group) {
    return _c('button', {
      key: group.category,
      staticClass: "category-chip",
      class: {
        active: _vm.isCategoryExpanded(group.category)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.jumpToCategory(group.category);
        }
      }
    }, [_vm._v(" " + _vm._s(group.category) + " "), _c('span', {
      staticClass: "chip-count"
    }, [_vm._v(_vm._s(group.reports.length))]), _vm.selectedCountInCategory(group) ? _c('span', {
      staticClass: "chip-dot"
    }) : _vm._e()]);
  }), 0) : _vm._e()]), !_vm.filteredGroups.length ? _c('div', {
    staticClass: "empty-state py-5"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("No reports match \"" + _vm._s(_vm.searchQuery) + "\".")])]) : _vm._e(), _vm._l(_vm.filteredGroups, function (group) {
    return _c('div', {
      key: group.category,
      staticClass: "report-group",
      attrs: {
        "id": _vm.groupId(group.category)
      }
    }, [_c('div', {
      staticClass: "report-group-header",
      on: {
        "click": function click($event) {
          return _vm.toggleCategory(group.category);
        }
      }
    }, [_c('h5', [_c('i', {
      staticClass: "fas fa-chevron-right chevron",
      class: {
        expanded: _vm.isCategoryExpanded(group.category)
      }
    }), _c('i', {
      class: ['fas', _vm.iconForCategory(group.category)]
    }), _vm._v(" " + _vm._s(group.category) + " "), _vm.selectedCountInCategory(group) ? _c('span', {
      staticClass: "category-selected-badge"
    }, [_vm._v(" " + _vm._s(_vm.selectedCountInCategory(group)) + " selected ")]) : _vm._e()]), _c('button', {
      staticClass: "select-all-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectAllInCategory(group);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.isCategoryFullySelected(group) ? "Clear" : "Select all") + " ")])]), _c('transition', {
      attrs: {
        "name": "collapse"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isCategoryExpanded(group.category),
        expression: "isCategoryExpanded(group.category)"
      }],
      staticClass: "report-grid"
    }, _vm._l(group.reports, function (report) {
      return _c('div', {
        key: report.key,
        staticClass: "report-card",
        class: {
          selected: _vm.isSelected(report.key)
        },
        on: {
          "click": function click($event) {
            return _vm.toggleSelection(report.key);
          }
        }
      }, [_c('div', {
        staticClass: "report-card-check"
      }, [_c('i', {
        staticClass: "fas",
        class: _vm.isSelected(report.key) ? 'fa-check-circle' : 'fa-circle'
      })]), _c('div', {
        staticClass: "report-card-body"
      }, [_c('div', {
        staticClass: "report-card-title"
      }, [_vm._v(" " + _vm._s(report.label) + " "), report.badge ? _c('span', {
        staticClass: "badge-pill"
      }, [_vm._v(_vm._s(report.badge))]) : _vm._e()]), _c('p', {
        staticClass: "report-card-desc"
      }, [_vm._v(_vm._s(report.description))]), _vm.lastRunByKey[report.key] ? _c('div', {
        staticClass: "report-card-lastrun"
      }, [_c('span', {
        staticClass: "status-dot",
        class: _vm.lastRunByKey[report.key].status
      }), _vm.lastRunByKey[report.key].status === 'completed' ? _c('span', [_vm._v(" Last generated " + _vm._s(_vm.timeAgo(_vm.lastRunByKey[report.key].completed_at || _vm.lastRunByKey[report.key].started_at)) + " ")]) : _vm.lastRunByKey[report.key].status === 'failed' ? _c('span', [_vm._v("Last attempt failed")]) : _c('span', [_vm._v("Generating now...")])]) : _vm._e()])]);
    }), 0)])], 1);
  })], 2)]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_vm.selectedCount ? _c('div', {
    staticClass: "selection-bar"
  }, [_c('div', {
    staticClass: "selection-bar-inner"
  }, [_c('div', {
    staticClass: "tray-chips"
  }, _vm._l(_vm.selectedKeys, function (key) {
    var _vm$findReportDefinit;

    return _c('span', {
      key: key,
      staticClass: "tray-chip"
    }, [_vm._v(" " + _vm._s(((_vm$findReportDefinit = _vm.findReportDefinition(key)) === null || _vm$findReportDefinit === void 0 ? void 0 : _vm$findReportDefinit.label) || key) + " "), _c('i', {
      staticClass: "fas fa-times tray-chip-remove",
      on: {
        "click": function click($event) {
          return _vm.toggleSelection(key);
        }
      }
    })]);
  }), 0), _c('div', {
    staticClass: "tray-actions"
  }, [_c('button', {
    staticClass: "btn-clear",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("Clear")]), _c('b-button', {
    staticClass: "btn-generate",
    attrs: {
      "variant": "primary",
      "disabled": _vm.isGenerating || _vm.requiresTarget && !_vm.selectedTargetAgentId
    },
    on: {
      "click": _vm.generateSelected
    }
  }, [_vm.isGenerating ? _c('b-spinner', {
    staticClass: "btn-generate-icon",
    attrs: {
      "small": ""
    }
  }) : _c('i', {
    staticClass: "fas fa-file-export btn-generate-icon"
  }), _c('span', [_vm._v("Generate")])], 1)], 1)])]) : _vm._e()]), _vm._m(2), _c('div', {
    staticClass: "reports-card"
  }, [_vm.isLoadingHistory && !_vm.historyRecords.length ? _c('div', {
    staticClass: "empty-state py-5"
  }, [_c('spinner-grow')], 1) : !_vm.historyRecords.length ? _c('div', {
    staticClass: "empty-state py-5"
  }, [_c('i', {
    staticClass: "fas fa-clock"
  }), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("No reports generated yet. Select one above to get started.")])]) : [_vm.isLoadingHistory ? _c('div', {
    staticClass: "history-refreshing"
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _c('span', [_vm._v("Refreshing...")])], 1) : _vm._e(), _c('transition-group', {
    staticClass: "history-list",
    attrs: {
      "name": "fade-in",
      "tag": "div"
    }
  }, _vm._l(_vm.historyRecords, function (row) {
    return _c('div', {
      key: row.id,
      staticClass: "history-row"
    }, [_c('div', {
      staticClass: "history-icon"
    }, [_c('i', {
      staticClass: "fas fa-file-excel"
    })]), _c('div', {
      staticClass: "history-main"
    }, [_c('div', {
      staticClass: "history-name"
    }, [_vm._v(_vm._s(row.file_name))]), _c('div', {
      staticClass: "history-time"
    }, [_vm._v(" " + _vm._s(_vm.timeAgo(row.completed_at || row.started_at)) + " "), _vm.requiresTarget && row.target_agent_name ? _c('span', {
      staticClass: "for-agent"
    }, [_vm._v(" · For " + _vm._s(row.target_agent_name))]) : _vm._e(), row.generated_by ? _c('span', [_vm._v(" · Generated by " + _vm._s(row.generated_by))]) : _vm._e()]), _c('div', {
      staticClass: "history-sheets"
    }, _vm._l(row.report_labels, function (label) {
      return _c('span', {
        key: label,
        staticClass: "sheet-chip"
      }, [_c('i', {
        staticClass: "fas fa-table"
      }), _vm._v(_vm._s(label) + " ")]);
    }), 0)]), _c('span', {
      staticClass: "pill",
      class: row.status
    }, [_c('i', {
      staticClass: "fas",
      class: _vm.statusIcon(row.status)
    }), _vm._v(" " + _vm._s(_vm.statusLabel(row.status)) + " ")]), _c('div', {
      staticClass: "history-action"
    }, [row.status === 'completed' ? _c('button', {
      staticClass: "btn-download",
      attrs: {
        "type": "button",
        "title": "Download"
      },
      on: {
        "click": function click($event) {
          return _vm.downloadRow(row);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-download"
    })]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])])]);
  }), 0), _c('pagination', {
    attrs: {
      "rows": _vm.historyList,
      "show-page-record": false
    },
    on: {
      "update:rows": function updateRows($event) {
        _vm.historyList = $event;
      }
    }
  })]], 2)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', {
    staticClass: "mb-1"
  }, [_vm._v("Generate Reports")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "target-picker-label"
  }, [_c('i', {
    staticClass: "fas fa-user-tie"
  }), _vm._v("Generate reports for")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-title"
  }, [_c('h2', {
    staticClass: "recent-title mb-1"
  }, [_vm._v("Recently Generated")])]);
}]

export { render, staticRenderFns }